<template>
  <v-app id="inspire">
    <v-content style="font-family:Microsoft JhengHei;">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-form ref="form" v-model="valid">
              <v-card class="elevation-12">
                <v-card-title class="red" dark>
                  <h2>
                    <font style="color:white">登入綁定Google帳號</font>
                  </h2>
                </v-card-title>
                <v-card-text>
                  <v-text-field
                    label="帳號"
                    prepend-icon="person"
                    type="text"
                    v-model="ac"
                    clearable
                    required
                    :rules="nameRules"
                    counter
                    maxlength="20"
                  ></v-text-field>

                  <v-text-field
                    id="password"
                    label="密碼"
                    prepend-icon="lock"
                    :append-icon="showPassword1 ? 'visibility_off' : 'visibility'"
                    :type="showPassword1 ? 'text' : 'password'"
                    @click:append="showPassword1 = !showPassword1"
                    v-model="pw"
                    clearable
                    required
                    :rules="pwRules"
                    counter
                    maxlength="20"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="grey lighten-3" style="color:black;" @click="reset();">清除</v-btn>
                  <v-btn
                    color="red"
                    style="color:white;"
                    :disabled="(!valid)"
                    class="ma-2"
                    @click="login($event);"
                  >確定</v-btn>
                </v-card-actions>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="backToLogin();">
                    <span class="mr-2" style="color:grey;font-size:12px;">回登入頁</span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import swal from "sweetalert2";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    ...mapGetters({
      idbServerUrl: ["getIdbServerUrl"]
    })
  },
  watch: {},

  data() {
    return {
      ac: "",
      pw: "",
      googleUserId: "",
      showPassword1: false,
      valid: true,
      account: null,
      method: null,
      txtAccountExists: "",
      nameRules: [
        v => !!v || "此欄位是必填",
        v => (v && v.length >= 6) || "必須大於6",
        v => (v && v.length <= 21) || "不能大於20"
      ],
      pwRules: [
        v => !!v || "密碼為必填",
        v => (v && v.length >= 3) || "必須大於3",
        v => (v && v.length <= 21) || "不能大於20"
      ],
      requiredRules: [v => !!v || "此欄位是必填"]
    };
  },
  methods: {
    ...mapActions(["updateUser"]),

    backToLogin() {
      var vm = this;
      vm.$router.push({ path: "/Login" });
    },

    reset() {
      this.txtAccountExists = "";
      this.$refs.form.reset();
      //this.$refs.form.validate();
      //this.$refs.form.resetValidation();
    },
    login() {
      var vm = this;
      if (this.$refs.form.validate()) {
        // json封裝;
        if (vm.googleUserId == "") {
          vm.loginError("請重新登入Google", 2000);
          vm.$router.push({ path: "/Login" });
          return;
        }
        var data = JSON.stringify({
          account: vm.ac,
          password: vm.pw,
          googleId: vm.googleUserId
        });

        vm.axios
          .post(vm.idbServerUrl + "idb/login", data, {
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then(function(response) {
            //console.log("response " + JSON.stringify(response));
            if ("200" == response.status) {
              vm.$localStorage.remove("google_userid");
              vm.$localStorage.set(
                "idb_login_token",
                "Bearer " + response.data.token
              );
              vm.$localStorage.set(
                "idb_login_token_expire_date",
                JSON.parse(
                  window.atob(
                    response.data.token.substring(
                      response.data.token.indexOf(".") + 1,
                      response.data.token.lastIndexOf(".")
                    )
                  )
                ).exp
              );

              vm.firstLogin = response.data.firstLogin;
              var token = vm.$localStorage.get("idb_login_token");
              vm.axios
                .get(vm.idbServerUrl + "idb/userProfile", {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: token
                  }
                })
                .then(function(response) {
                  if (response.data.memberAccount.status === "Y") {
                    var authFuncList = [];
                    var sourceAuthFuncList = response.data.authFuncList;
                    sourceAuthFuncList.forEach(function(element) {
                      if (element.depth == "0") {
                        authFuncList.push(vm.parseFunc(element));
                      }
                    });
                    sourceAuthFuncList.forEach(function(element) {
                      if (element.depth == "1") {
                        authFuncList.forEach(function(authFunc) {
                          if (element.parentFunc.funcId == authFunc.funcId) {
                            if (authFunc.children == undefined) {
                              authFunc.children = [];
                            }
                            authFunc.children.push(vm.parseFunc(element));
                          }
                        });
                      }
                    });

                    vm.$localStorage.set(
                      "userProfileStr",
                      JSON.stringify(response.data)
                    );
                    vm.$localStorage.set(
                      "idb_funcIdList",
                      JSON.stringify(authFuncList)
                    );

                    if (vm.firstLogin) {
                      vm.$localStorage.set(
                        "idb_funcIdList",
                        JSON.stringify([])
                      );
                      vm.loginChangePW();
                    } else {
                      vm.loginGo();
                    }
                  } else {
                    vm.loginError("無法登入系統 請洽系統管理者", 3000);
                  }
                })
                .catch(function(error) {
                  console.log("@@@@99 " + error);
                });
            }
          })
          .catch(function(error) {
            if (error.response) {
              console.log("@@@@5 " + error.response.status);
              if ("401" == error.response.status) {
                // vm.processStatus = false;
              }
            } else if (error.request) {
              console.log("@@@@4 " + error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log("@@@@1 " + error.message);
            }
            console.log("@@@@2 " + JSON.stringify(error.config));
            // 失敗回應
            console.log("@@@@3 " + error);
            vm.loginError("帳號或密碼輸入錯誤", 2000);
          });
      }
    },
    loginError(par1, par2) {
      swal({
        title: par1,
        // text: "I will close in 5 seconds.",
        timer: par2,
        allowOutsideClick: false,
        confirmButtonText: "確認",
        showConfirmButton: true
      });
    },
    parseFunc(obj) {
      var newFunc = {
        icon: obj.description,
        text: obj.name,
        funcId: obj.funcId
      };
      if (this.isNotBlankUtil(obj.path)) {
        newFunc.link = obj.path;
      }
      //console.log("newFunc " + JSON.stringify(newFunc));
      return newFunc;
    },
    loginGo() {
      swal({
        title: "歡迎",
        // text: "I will close in 5 seconds.",
        timer: 1000,
        showConfirmButton: false
      });
      var vm = this;
      vm.$router.push({ path: "/caseList" });
    },
    loginChangePW() {
      swal({
        title: "第一次登入系統請先更改帳號及密碼",
        type: "warning",
        allowOutsideClick: false,
        confirmButtonText: "確認",
        showConfirmButton: true
      });
      var vm = this;
      vm.$router.push({ path: "/ChangePW" });
    }
  },
  mounted() {
    this.$refs.form.validate();
  },
  created() {
    let vm = this;
    vm.googleUserId = vm.$localStorage.get("google_userid");
    swal({
      title: "尚未完成Google登入流程",
      html: "這個登入方式尚未完成註冊，請選擇要繼續註冊流程或回登入頁面。",
      type: "warning",
      allowOutsideClick: false,
      showConfirmButton: true
    });
  }
};
</script>